var map = {
	"./roof-slope-0-deg.png": 7316,
	"./roof-slope-10-deg.png": 76666,
	"./roof-slope-15-deg.png": 8914,
	"./roof-slope-20-deg.png": 8999,
	"./roof-slope-25-deg.png": 58228,
	"./roof-slope-30-deg.png": 45530,
	"./roof-slope-35-deg.png": 33496,
	"./roof-slope-40-deg.png": 17922,
	"./roof-slope-45-deg.png": 91993,
	"./roof-slope-5-deg.png": 63026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25475;